import { getPercentage } from '../../utils/utils'

export const lineOptions = {
  layout: {
    padding: {
      left: 0,
      right: 36,
      top: 0,
      bottom: 0,
    },
  },
  plugins: {
    datalabels: {
      color(context) {
        return context?.dataset?.borderColor
      },
      font: {
        weight: 'bold',
      },
      formatter(value, context) {
        if (context.dataIndex === context.dataset.data.length - 1) {
          return `               ${getPercentage(
            context?.dataset?.data[0],
            context?.dataset?.data[Number(context?.dataset?.data?.length) - 1],
          ).toFixed(0)}%${context.datasetIndex === 0 ? '\n\n' : ''}`
        }
        return ''
      },
    },
  },
  title: { display: false },
  legend: { display: false },
  maintainAspectRatio: false,
  scales: {
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          borderDash: [2, 4],
          drawBorder: false,
        },
        ticks: {
          beginAtZero: true,
          suggestedMin: 0,
        },
      },
    ],
  },
}
